module.exports = __webpack_public_path__ + "img/no-bot.dedc218b.svg";